import { Flame } from 'lucide-react';
import { MARQUEE_ITEMS } from '../../data/content';

const MarqueeRow = ({ ariaHidden = false }) => (
  <div className="flex items-center shrink-0" aria-hidden={ariaHidden}>
    {MARQUEE_ITEMS.map((item) => (
      <span
        key={`${ariaHidden}-${item}`}
        className="mx-7 flex items-center gap-7 font-mono text-sm uppercase tracking-[0.28em] text-amber-300/70 whitespace-nowrap"
      >
        {item}
        <Flame className="w-4 h-4 text-amber-400/50" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative border-y border-amber-400/15 bg-[#0A2847]/50 backdrop-blur-sm py-5 overflow-hidden"
  >
    <div className="flex w-max animate-marquee">
      <MarqueeRow />
      <MarqueeRow ariaHidden />
    </div>
  </div>
);

export default Marquee;
